import type { FC, HTMLProps } from 'react';
import { useCallback, useState } from 'react';

import {
    Card as UICard,
    Sizes,
    transformWorthString,
    theme,
} from '@catalyze/ui';
import type { ILead } from 'api/types/lead';
import { Status } from 'api/types/lead';
import { LeadGroups } from 'constants/leadGroups';
import { usePropertyUrl } from 'features/RealEstate/utils/usePropertyUrl';
import { leadGroupColor } from 'utils/leadGroupColor';

import { StyledNewTag, StyledNewMobileTag } from './styled';

const mappedCheckboxTitle = {
    [LeadGroups.RECOMMENDED]: 'Contacted',
    [LeadGroups.CONTACTED]: null,
    [LeadGroups.ACTIVE_CONVERSATION]: null,
    [LeadGroups.LISTED]: null,
    [LeadGroups.SOLD]: null,
    [LeadGroups.CLOSED]: null,
    [LeadGroups.ARCHIVED]: null,
    [LeadGroups.SEARCH]: null,
};

const getText = (type: LeadGroups, edm: ILead['edms']) => {
    switch (type) {
        case LeadGroups.CONTACTED:
            return 'See property details';
        default:
            return '';
    }
};

interface IFinanceCardProps {
    type: LeadGroups;
    data: ILead;
    onCheckboxChange?: Function;
}

export const Card: FC<IFinanceCardProps> = ({
    type,
    data: {
        propertyLeadId,
        status,
        address,
        city,
        state,
        categories,
        estimatedMarketValue,
        edms,
    },
    onCheckboxChange,
}) => {
    const [isChecked, setChecked] = useState(false);
    const checkboxTitle = mappedCheckboxTitle[type];
    const clickCallbackFunctor = usePropertyUrl();
    // const queryClient = useQueryClient();

    // const {
    //     mutate: updateStatus,
    //     isLoading,
    //     isError,
    // } = useUpdateStatusMutation({
    //     onSuccess: async () => {
    //         await queryClient.invalidateQueries('leads');
    //         await queryClient.invalidateQueries('infiniteLeads');
    //         await queryClient.invalidateQueries('leads-worth');
    //         setChecked(false);
    //     },
    // });

    const onChangeHandler = useCallback(() => {
        // updateStatus({ newStatus: nextLeadStatus(status), id: leadId });
        if (onCheckboxChange) {
            onCheckboxChange(!isChecked);
        }

        setChecked(!isChecked);
    }, [setChecked, isChecked, onCheckboxChange]);

    // useEffect(() => {
    //     isError && setChecked(false);
    // }, [isError, setChecked]);

    const Badge =
        status === Status.NEW
            ? (props: HTMLProps<HTMLSpanElement>) => (
                  <span {...props}>
                      <StyledNewTag value="New" size={Sizes.M} />
                      <StyledNewMobileTag />
                  </span>
              )
            : undefined;

    return (
        <UICard
            isLoading={false}
            heading={address}
            worth={transformWorthString(parseInt(estimatedMarketValue, 10))}
            address={`${city}, ${state}`}
            checkboxValue={isChecked}
            categories={categories}
            onCheckboxChange={onChangeHandler}
            onCardClick={clickCallbackFunctor(propertyLeadId.toString())}
            checkboxTitle={checkboxTitle}
            badge={Badge}
            footerButtonProps={{
                text: getText(type, edms),
                color: leadGroupColor({ theme, type }),
            }}
        />
    );
};
